import { Box, Grid} from "@mui/material";
import { useTranslation } from "react-i18next";
import TextWithIcon from "./text-with-icon";

export default function FooterComponent() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      text: "accessibility",
      link: "https://www.homeequitybank.ca/wp-content/uploads/HomeEquity-Bank-Accessibility-Plan2023-2024.pdf",
    },
    { text: "privacy-policy", link: "https://www.homeequitybank.ca/privacy/" },
    { text: "use-term", link: "https://www.homeequitybank.ca/legal/" },
    {
      text: "resolving-complaints",
      link: "https://www.homeequitybank.ca/complaints",
    },
    { text: "regulatory", link: "https://www.homeequitybank.ca/regulatory/" },
    {
      text: "security-awareness",
      link: "https://www.homeequitybank.ca/security-awareness/",
    },
    {
      text: "codes-of-conduct",
      link: "https://www.homeequitybank.ca/voluntary-codes-of-conduct/",
    },
  ];

  return (
    <Box className="bg-bgColor px-5 py-10">
      <Grid container rowSpacing={{xs: 2,sm: 2 ,md: 3}} columnSpacing={{ xs: 1, sm: 3, md: 4 }}>
        <Grid  size={12}>
          <TextWithIcon
            textClassName="text-white text-base font-semibold"
            text={t("copyrigh")}
          />
        </Grid>
        <Grid
          container
          wrap="wrap"
          alignItems="center"          
        >
          {footerLinks.map((item, index) => (
            <div
              key={index}
              className="flex 
            w-full sm:w-auto
            sm:flex-row flex-col"
            >
              <TextWithIcon
                iconSrc={item.icon}
                className="text-white w-400 text-base no-underline lg:hover:underline lg:hover:underline-offset-4"
                text={t(item.text)}
                href={item.link}
                target="_blank"
              />
            </div>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
